import "./BoxesDeleteModal.scss";

import BoxesDeleteModal from "./BoxesDeleteModal";

export default BoxesDeleteModal;
